import { MutationFunction } from 'react-query';

// The reticulation document is one per mine model: a save that starts before the last one commits loses to it.
let tail: Promise<unknown> = Promise.resolve();

export const enqueueReticulationWrite = <TData>(write: () => Promise<TData>): Promise<TData> => {
  const next = tail.then(write);
  tail = next.catch(() => undefined);
  return next;
};

export const serialiseReticulationWrites = <TArgs extends unknown[], TData, TModel>(
  mutationFnFactory: (...args: TArgs) => MutationFunction<TData, TModel>,
) => (...args: TArgs): MutationFunction<TData, TModel> => {
  const write = mutationFnFactory(...args);
  return (model) => enqueueReticulationWrite(() => write(model));
};
